// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__17ifo","addWidgetButton":"Header_addWidgetButton__jVnC1","dashboardTabs":"Header_dashboardTabs__-vUku","active":"Header_active__2MJr4"};